/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_meta_og_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingénieur logiciel spécialisé dans la création de systèmes web et backend évolutifs avec TypeScript, Java, Go et Rust. Expert en API, architecture cloud, performances et applications sécurisées.`)
};

const en_meta_og_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software engineer building scalable web and backend systems with TypeScript, Java, Go and Rust. Expert in APIs, cloud architecture, performance and secure applications.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const meta_og_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.meta_og_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("meta_og_description", locale)
	if (locale === "fr") return fr_meta_og_description(inputs)
	return en_meta_og_description(inputs)
};